import { render, staticRenderFns } from "./RelatedPersonnel.vue?vue&type=template&id=4c3f6260&scoped=true&"
import script from "./RelatedPersonnel.vue?vue&type=script&lang=js&"
export * from "./RelatedPersonnel.vue?vue&type=script&lang=js&"
import style0 from "./RelatedPersonnel.vue?vue&type=style&index=0&id=4c3f6260&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3f6260",
  null
  
)

export default component.exports